/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentsListByIdQueryResponse, GetFragmentsListByIdPathParams, GetFragmentsListById404 } from "../models/GetFragmentsListById";

export function getGetFragmentsListByIdUrl(id: GetFragmentsListByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/fragments/${id}` as const }
  return res
}

/**
 * @summary Get one fragment by id with poster, social upload statuses and external delivery status
 * {@link /fragments/:id}
 */
export async function getFragmentsListById(id: GetFragmentsListByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFragmentsListByIdQueryResponse, ResponseErrorConfig<GetFragmentsListById404>, unknown>({ method : "GET", url : getGetFragmentsListByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}